import React from "react";
import { Box, Typography, TextField, Button } from "@mui/material";

export const Step4 = (props) => {
  const {
    register,
    errors,
    calculateTotalFileSize,
    setUploadedBienesFiles,
    uploadedBienesFiles,
  } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Listado de bienes afectados</Typography>
      <Typography variant="p">
        Por favor, indique el nombre, fecha de compra, costo y cualquier otra
        información relevante.
      </Typography>

      <TextField
        {...register("bienesAfectados", {
          required: "El campo es obligatorio",
        })}
        label="Describa los bienes afectados."
        placeholder={`Ej: Televisor, fecha de compra, coste, etc.\n     Sofá, fecha de compra, coste, etc.`}
        fullWidth
        required
        multiline
        minRows={4}
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.bienesAfectados}
        helperText={errors.bienesAfectados?.message}
      />

      <Typography variant="subtitle1">
        Sube documentos, fotos o videos
      </Typography>
      <Typography
        variant="body2"
        color={
          calculateTotalFileSize() > 24 * 1024 * 1024 ? "error" : "inherit"
        }
      >
        Tamaño total:{" "}
        {Math.round((calculateTotalFileSize() / 1024 / 1024) * 100) / 100} MB /
        25 MB
      </Typography>
      <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
        Seleccionar archivos
        <input
          type="file"
          hidden
          multiple
          accept="image/*, video/*, application/pdf"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setUploadedBienesFiles((prevFiles) => [...prevFiles, ...newFiles]);
          }}
        />
      </Button>

      {uploadedBienesFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Archivos seleccionados:</Typography>
          <ul>
            {uploadedBienesFiles.map((file, index) => (
              <li key={index}>
                {file.name}
                <Button
                  variant="text"
                  color="error"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    setUploadedBienesFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index)
                    );
                  }}
                >
                  ✖︎ Eliminar
                </Button>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
};

export default Step4;
